// src/components/marketing/aniversariantes/flyer-texto.js
// =======================================================================
// O TEXTO que entra na arte dos aniversariantes — regras puras, testadas.
// =======================================================================
// Vieram da ferramenta que rodava fora do portal e continuam valendo: a arte
// tem largura fixa, então o nome precisa CABER sem encolher a fonte de todo
// mundo. As decisões estão aqui (e não dentro do desenho) para poderem ser
// conferidas sem abrir um canvas.
// =======================================================================

export const MESES = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

const CONECTORES = /^(de|da|do|das|dos|e)$/i;

/**
 * "MARIA DA SILVA SANTOS" -> "Maria da Silva Santos".
 * O cadastro grava tudo em maiúsculas; a arte mostra como se escreve um nome.
 * ⚠️ Os conectores ficam minúsculos — "Maria DA Silva" salta aos olhos na arte.
 */
export function tituloDeNome(texto) {
    return String(texto || '')
        .toLowerCase()
        .replace(/(^|[\s'-])\p{L}/gu, (ch) => ch.toUpperCase())
        .replace(/\s(De|Da|Do|Das|Dos|E)\s/g, (m) => m.toLowerCase());
}

/**
 * Abrevia os nomes DO MEIO, preservando os dois primeiros e o último por
 * inteiro: "Douglas Flaudige Farias de Oliveira" -> "Douglas Flaudige F. de
 * Oliveira".
 *
 * ⚠️ Conectores ("de", "da", "dos") NÃO contam como nome e NÃO são abreviados —
 *    sem isso o "de" do meio virava "D." e o nome ficava ilegível.
 * ⚠️ Até três nomes significativos, devolve inteiro: não há meio para abreviar.
 */
export function abreviarNome(nome) {
    const palavras = String(nome || '').trim().split(/\s+/);
    if (palavras.length <= 1) return String(nome || '');

    const significativos = [];
    palavras.forEach((p, i) => { if (!CONECTORES.test(p)) significativos.push(i); });
    if (significativos.length <= 3) return palavras.join(' ');

    const doMeio = new Set(significativos.slice(2, significativos.length - 1));
    return palavras
        .map((p, i) => (doMeio.has(i) ? `${p.charAt(0).toUpperCase()}.` : p))
        .join(' ');
}

/** O nome como sai impresso: caixa de nome próprio + meio abreviado. */
export function nomeNaArte(nome) {
    return abreviarNome(tituloDeNome(nome));
}
